<template>
  <div class="notification is-info is-light">
    <p>
      Länder mit Angemessenheitsbeschluss der EU sind Ländern innerhalb der EU/EWR gleichgestellt.
      Für diese Länder müssen entsprechend keine weiteren Maßnahmen ergriffen werden. Eine Ausnahme
      besteht für die USA, da der Angemessenheitsbeschluss nur für bestimmte Bereiche und
      Unternehmen gilt - für die USA sollten daher momentan zusätzlich die SCC
      (Standardvertragsklauseln) der EU abgeschlossen werden. Eine Liste der Länder mit
      Angemessenheitsbeschluss der EU finden Sie hier:
      <a
        href="https://datenschutz.hessen.de/datenschutz/internationaler-datentransfer/angemessenheitsbeschluesse-der-europaeischen-kommission"
        target="_blank"
        rel="noopener noreferrer"
        class="external-link"
      >
        Angemessenheitsbeschlüsse der Europäischen Kommission
        <b-icon icon="open-in-new" size="is-small" />
      </a>
    </p>
    <p>
      Die Liste mit durch das Data Privacy Framework EU-USA zertifizierten Unternehmen finden Sie
      hier:
      <a
        href="https://www.dataprivacyframework.gov/list"
        target="_blank"
        rel="noopener noreferrer"
        class="external-link"
      >
        Data Privacy Framework Participant List
        <b-icon icon="open-in-new" size="is-small" />
      </a>
    </p>
    <p>
      Die Standardvertragsklauseln werden vom Research Support des FB 16 bei Vertragsschluss mit dem
      Vertragspartner aufgesetzt. Bei Fragen zu Verträgen wenden Sie sich an den Research Support.
    </p>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped>
.notification p + p {
  margin-top: 0.75rem;
}

.external-link {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  word-break: break-all;
}
</style>
